export const MAX_FILE_SIZE_MB = 50
export const MAX_FILE_SIZE    = MAX_FILE_SIZE_MB * 1024 * 1024

export const ACTIVE_STATUSES = new Set(['queued', 'running'])

export const STATUS_GROUPS = ['queued', 'running', 'completed', 'failed']
